import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { InternalLinkUI } from './ui';

export class InternalLink extends PureComponent {
    static displayName = 'InternalLinkContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <InternalLinkUI {...rest} />;
    }
}

export const InternalLinkContainer = compose()(InternalLink);
